import React from "react";

import demoTruck from "../../../assets/images/demo_truck.jpg";

const CategoryItem = ({ 
  renderData,
  onClick,
}) => {
  return (
    <div className="featured-section">
      {renderData.length > 0 ? renderData.map((_item, index) => {
        let cardName = (_item?.make && (_item?.make?.name) + " " + _item?.model && (_item?.model?.name)) ?? _item?.name ?? "N/A";
        let cardDescription = _item?.assignee?.displayName ?? _item?.name ?? "N/A";
        let categoryType = (_item?.make && (_item?.make?.__typename || "Make") + " | " + (_item?.model && (_item?.model?.__typename || "Model"))) ?? _item?.__typename ?? "N/A";

        return(
          <div key={`category-item-${index}`} className="featured-item" onClick={() => onClick(_item)}> 
            <div className="img-div">
              <img src={_item?.assetMedias && _item?.assetMedias?.length !== 0 ? _item?.assetMedias[0].media : demoTruck ?? demoTruck} alt="category-img" />
            </div>
            <div className="px-3">
              <h3 className="text-info-css">{cardName}</h3>
              <p className="test-des">
                { cardDescription || "N/A"}
              </p>
              <p className="make-modal">{categoryType ?? "N/A"}</p>
            </div>

            <div className="hidden-hover-text">View</div>
          </div>
        );
      }) : <h3>Data not available</h3>}
    </div>
  );
};

export default CategoryItem;
